import { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import AvailabilityTimeline from "../../components/HR/AvailabilityTimeline/AvailabilityTimeline";
import DailyAvailability from "../../components/HR/DailyAvailability/DailyAvailability";
import YearlyAvailability from "../../components/HR/YearlyAvailability/YearlyAvailability";

const AvailabilityPage = () => {
  const [view, setView] = useState<"month" | "day" | "year">("month");

  return (
    <>
      <Box
        flexWrap={{ xs: "wrap", lg: "nowrap" }}
        display="flex"
        justifyContent="center"
        pt={3}
      >
        <ToggleButtonGroup
          exclusive
          value={view}
          onChange={(_, nextView) => nextView && setView(nextView)}
          aria-label="Availability view"
        >
          <ToggleButton value="month">Per Month</ToggleButton>
          <ToggleButton value="day">Per Day</ToggleButton>
          <ToggleButton value="year">Per Year</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {view === "month" && <AvailabilityTimeline />}
      {view === "day" && <DailyAvailability />}
      {view === "year" && <YearlyAvailability />}
    </>
  );
};

export default AvailabilityPage;
